import style from '../index.module.less'
import { Button, Space, Input, MenuProps, Popconfirm, Dropdown, Modal } from "antd";
import React, { useState } from 'react';
import { ShareAltOutlined } from "@ant-design/icons";
import { FileEditingOne, FilePdfOne, FileText, ImageFiles } from '@icon-park/react'
import { noteServer, getNoteName } from "@/common/notesServer";
import { ipcSend } from "@/common/ipc";
import { atom, useAtom } from "jotai";

import { pdfAtom } from '../NewNoteIndex'
import {useTranslation} from "react-i18next";
import {IconClose} from "@/Icon";
import {imgPathPerfix} from "@/utils";

const Share = (props: { getSaveData: () => TNote }) => {
    const {t} = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const setPdfAtom = useAtom(pdfAtom)[1]

    //@ts-ignore
    window.exitPdf = () => {
        setPdfAtom(false)
        noteServer
    }

    const showModal = async () => {
        window.GSearchClose?.()
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    async function text() {
        const name = getNoteName()
        if (!name) return noteServer.openTip('warning', '请输入笔记名')
        let text = window.GEditor.getText()
        ipcSend('save-text-to-system', name, text)
        setIsModalOpen(false);
    }
    async function image() {
        setIsModalOpen(false);
        window.getEditorCanvas().then(function (c) {
            ipcSend('save-img-to-system', c.toDataURL("image/png"))
        });
    }
    async function pdf() {
        setIsModalOpen(false);
        // setPdfAtom(true)
        const data = await props.getSaveData()
        setTimeout(() => {
            ipcSend('save-pdf-to-system', data.id)
        }, 300);
    }
    async function pnote() {
        setIsModalOpen(false);
        const name = getNoteName()
        if (!name) return noteServer.openTip('warning', '请输入笔记名')
        let doc = window.GEditor.getHTML()
        window.getEditorCanvas().then(function (c) {
            ipcSend('save-note-to-system', name, JSON.stringify({
                img: c.toDataURL("image/png"),
                doc,
                name
            }))
        });
    }

    return (
        <>
            <Button type="primary" icon={<ShareAltOutlined />} onClick={showModal}></Button>
            <Modal centered={true} title={t("Share")} open={isModalOpen} onOk={handleOk}
                   closeIcon={<IconClose/>}
                   onCancel={handleCancel} width={450} footer={''}>
                <div style={{height:'1px',backgroundColor:'#efefef',marginTop:'6px',marginBottom:'4px'}}></div>
                <p className={style.shareItem} onClick={text}><img className='img-small mr-8' src={imgPathPerfix()+"note_share_text.png"}/> {t("Text")} </p>
                <p className={style.shareItem} onClick={image}><img className='img-small mr-8' src={imgPathPerfix()+"note_share_image.png"}/>{t("Image")}</p>
                <p className={style.shareItem} onClick={pdf}><img className='img-small mr-8' src={imgPathPerfix()+"note_share_pdf.png"}/>{t("Pdf")}</p>
                {/*<p className={style.shareItem} onClick={pnote}><FileEditingOne theme="outline" size="24" fill="#333" /> pnote</p>*/}
            </Modal>
        </>
    )
}
export default Share



















